module.exports = __webpack_public_path__ + "static/media/smx_logo_black.510bef9f.svg";